/**
 * VH-83: Editor for a single ordered step (text + optional timer + min oven temp).
 */

import { useTranslation } from 'react-i18next'
import { TrashIcon } from '@heroicons/react/24/outline'

export default function RecipeStepEditor({ value, onChange, onRemove, index }) {
  const { t } = useTranslation()
  const update = (patch) => onChange?.({ ...value, ...patch })

  return (
    <div
      data-testid={`step-row-${index}`}
      className="border border-gray-200 rounded-lg p-3 space-y-2 bg-surface-container"
    >
      <div className="flex items-center justify-between">
        <span className="text-sm font-semibold text-gray-700">
          {t('recipes.steps.stepNumber', { num: value.step_order })}
        </span>
        <button
          type="button"
          onClick={() => onRemove?.()}
          className="p-1.5 text-gray-400 hover:text-red-600"
          title={t('recipes.steps.remove')}
          aria-label={t('recipes.steps.remove')}
        >
          <TrashIcon className="h-4 w-4" />
        </button>
      </div>
      <textarea
        rows={2}
        value={value.text || ''}
        onChange={(e) => update({ text: e.target.value })}
        placeholder={t('recipes.steps.textPlaceholder')}
        className="form-input w-full text-sm"
        data-testid={`step-text-${index}`}
      />
      <div className="grid grid-cols-2 gap-2">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">
            {t('recipes.steps.timer')}
          </label>
          <input
            type="number"
            min="0"
            value={value.timer_minutes ?? ''}
            onChange={(e) =>
              update({
                timer_minutes:
                  e.target.value === '' ? null : parseInt(e.target.value, 10),
              })
            }
            className="form-input w-full text-sm"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">
            {t('recipes.steps.minOvenTemp')}
          </label>
          <input
            type="number"
            min="0"
            value={value.min_oven_temp_c ?? ''}
            onChange={(e) =>
              update({
                min_oven_temp_c:
                  e.target.value === '' ? null : parseInt(e.target.value, 10),
              })
            }
            className="form-input w-full text-sm"
          />
        </div>
      </div>
    </div>
  )
}
